export default "__VITE_ASSET__RZhdbGVo__"